import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { metaStyle as meta } from '../utils/shopHealth';
import AddFeedByUrl from '../components/AddFeedByUrl';

// Connect a feed by URL — the path that keeps re-syncing.
//
// It used to live inside the `Advanced` disclosure at the very bottom of
// `/feeds`: 19.0 phone screens down at the live account's size, and 41 at a
// hundred shops. THE BETTER OF THE TWO SUPPLY PATHS WAS THE MORE HIDDEN ONE —
// a URL feed is re-fetched on a schedule while an uploaded file freezes from the
// moment it lands, and of 281 scheduled ingests measured on 2026-09-05, 281
// changed the catalogue.
//
// Its component still confirms the column mapping BEFORE the feed exists,
// because a scheduled sync has nobody to ask.

const ConnectFeedPage: React.FC = () => {
  // Stays put on success for the same reason the upload page does: the form
  // reports what it made, and navigating away throws that report away.
  const [connected, setConnected] = useState(false);

  return (
    <>
      <p style={{ ...meta, marginBottom: '0.75rem' }}>
        <Link to="/feeds" data-testid="back-to-feeds">← Your shops</Link>
      </p>

      <section className="feeds-section" data-testid="connect-feed-page">
        <h2>Connect a feed by URL</h2>
        <p className="no-data">
          For a shop that publishes a feed at a web address. We fetch it on a schedule, so its
          prices and products stay in step with the shop.
        </p>

        <AddFeedByUrl onFeedCreated={() => setConnected(true)} />

        {connected && (
          <p style={{ marginTop: '1rem' }} data-testid="connect-done">
            <Link to="/feeds">← Back to your shops</Link>
          </p>
        )}
      </section>
    </>
  );
};

export default ConnectFeedPage;
